import React, { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useUpgradable } from 'hooks/upgradable'
import { getIntegrationUrl } from 'utilities/url'
import {
    IntegrationItem,
    Header, Heading, ToggleArrow, ArrowRight,
    Content
} from './s'
import { Plain } from 'components/button'
import Paragraph from 'components/typography/paragraph'
import data from 'pages/integrations/pages/integration/data'
import Link from 'components/link'
import Instances from 'pages/integrations/lists/instances'
import { integrationUnconfiguredId } from 'pages/integrations/constants'
import { getUpgradeProps } from 'pages/integrations/utilities/upgrade'
import UpgradeModal from 'modals/upgrade'
import { Plus, ArrowUpCircle } from 'styled-icons/feather'
import { Integration as IntegrationIcon } from 'components/feather'

const Integration = ({ type, instances = [], name, upgradable }) => {
    const { formatMessage } = useIntl()

    const navigate = useNavigate()
    const checkUpgradable = useUpgradable()

    const [upgrading, setUpgrading] = useState(false)

    const Icon = data?.[type]?.()?.icon ?? IntegrationIcon

    const hasInstances = !!instances.length

    const multipleInstancesUpgradable = checkUpgradable({ feature: 'integrations-multiple-instances' })

    return (
        <>
            <IntegrationItem {...(!hasInstances ? { as: 'div' } : null)}>
                <Header
                    {...(!hasInstances ? {
                        as: Link,
                        to: getIntegrationUrl({ type, id: integrationUnconfiguredId })
                    } : null)}>
                    {!!Icon && <Icon size={40} />}
                    <Heading className="compact">{name}</Heading>
                    {hasInstances && (
                        <>
                            <Paragraph className="caption compact">
                                <FormattedMessage
                                    id="integration_instance_count"
                                    defaultMessage="{count, plural, =0 {No connections} one {1 connection} other {{count} connections}}"
                                    values={{ count: instances.length }} />
                            </Paragraph>
                            <ToggleArrow size={24} />
                        </>
                    )}
                    {!hasInstances && (
                        <>
                            <Plain className="constructive">
                                <FormattedMessage
                                    id="integration_action_instance_new"
                                    defaultMessage="New connection" />
                            </Plain>
                            <ArrowRight size={24} />
                        </>
                    )}
                </Header>
                {hasInstances && (
                    <Content>
                        <Paragraph>
                            <FormattedMessage
                                id={`integration_${type}_description`}
                                defaultMessage={`About ${name}`} />
                        </Paragraph>
                        <Plain
                            {...((upgradable || multipleInstancesUpgradable) ? {
                                onClick: () => setUpgrading(true)
                            } : {
                                as: Link,
                                to: getIntegrationUrl({ type, id: integrationUnconfiguredId })
                             })}
                            className="constructive"
                            icon={(upgradable || multipleInstancesUpgradable) ? <ArrowUpCircle size={24} /> : <Plus size={24} />}>
                            <FormattedMessage
                                id="integration_action_instance_new"
                                defaultMessage="New connection" />
                        </Plain>
                        <Instances instances={instances} />
                    </Content>
                )}
            </IntegrationItem>
            {(upgradable || multipleInstancesUpgradable) && (
                <UpgradeModal
                    heading={formatMessage({
                        id: 'integration_action_instance_new',
                        defaultMessage: 'New connection'
                    })}
                    dismiss={() => setUpgrading(false)}
                    {...(upgrading ? { upgrade: getUpgradeProps({ upgradable }) } : null)}
                    callback={() => navigate(getIntegrationUrl({ type, id: integrationUnconfiguredId }))}
                    salt="integrations" />
            )}
        </>
    )
}

export default Integration